import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=5aa1587a&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=5aa1587a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1587a",
  null
  
)

export default component.exports